import axios from "axios";

const baseUrl =
  process.env.NODE_ENV == "production"
    ? "https://ycc-test-bg.hnchxwl.com:10443"
    : "http://192.168.8.123:8081";
// const baseUrl =
//   process.env.NODE_ENV == "production"
//     ? "http://192.168.8.163:8081"
//     : "http://192.168.8.8:8081";

const payUrl =
  process.env.NODE_ENV == "production"
    ? "https://payment.iot.xin" //
    : "https://payment.iot.xin"; // wx 支付线下需走线上地址 https://payment.iot.xin 、 支付宝可走线下地址 http://192.168.8.154:8080 （线下本机地址）

const yunMobile = {
  sendPhone(params) {
    return axios({
      url: baseUrl + "/api/park/xsq/mobile/park/qrcode/wpckz",
      method: "post",
      data: params,
      msg: true
    });
  },
  sendCar(params) {
    return axios({
      url: baseUrl + "/api/park/xsq/mobile/park/qrcode/affirm",
      params: params,
      msg: true
    });
  },
  getCarin(params) {
    return axios({
      url: baseUrl + "/api/park/xsq/mobile/park/qrcode/fee",
      method: "post",
      data: params,
      msg: true
    });
  },
  getCarinBranch(params) {
    return axios({
      url: baseUrl + "/api/nfmobile/out_expense",
      data: params,
      method: "POST",
      msg: true
    });
  },
  getCarinByMsg(params) {
    return axios({
      url: baseUrl + "/api/park/xsq/mobile/park/qrcode/outfindmsg",
      params: params
    });
  },
  getCode(params) {
    console.log(params);
    return axios({
      url: payUrl + "/xsq/web/wx/getcode",
      params: params
    });
  },
  payByWx(data) {
    return axios({
      url: baseUrl + "/api/pay/pay",
      method: "post",
      data
    });
  },
  payByZfb(data) {
    return axios({
      url: baseUrl + "/api/pay/pay",
      method: "post",
      data
    });
  },
  payReturn(params) {
    return axios({
      url: baseUrl + "/api/park/xsq/mobile/park/qrcode/payreturn",
      params: params,
      msg: true
    });
  },
  getRuleList() {
    return axios({
      url: baseUrl + "/api/business/voucher/rules",
      method: "POST"
    });
  },
  buyRule(params) {
    return axios({
      url: baseUrl + "/api/business/voucher/buydiscount",
      method: "GET",
      params
    });
  },
  getUserMoney(params) {
    return axios({
      url: baseUrl + `/api/business/getyue/${params}`
    });
  },
  testCallback() {
    return axios({
      url: baseUrl + `/api/park/xsq/web/park/http/test`
    });
  },
  openPark(data) {
    return axios({
      url: baseUrl + "/api/unattend/xsq/mobile/park/qrcode/autoWhite",
      method: "POST",
      data
    });
  },
  openParkByPhone(data) {
    return axios({
      url: baseUrl + "/api/nfmobile/unlicensedcar",
      method: "POST",
      data
    });
  },
  getCodeDetail(data) {
    return axios({
      url: baseUrl + "/api/business/findQrCodeIntime",
      method: "POST",
      data
    });
  },
  checkCode(params) {
    return axios({
      url: baseUrl + "/api/business/voucher/checkDisQrCode",
      method: "POST",
      params
    });
  },
  submitCode(data) {
    return axios({
      url: baseUrl + "/api/business/voucher/app/add",
      method: "POST",
      data
    });
  },
  //扫码开卡/充值输入车牌查询
  getQrcodeFindScan(data) {
    return axios({
      url: baseUrl + "/api/business/voucher/findScan",
      method: "POST",
      data
    });
  },
  //扫码开卡及创建充值订单
  createOrder(data) {
    return axios({
      url: baseUrl + "/api/business/voucher/scanRecharge",
      method: "POST",
      data
    });
  },
  //缴费历史记录
  rechargeRecordList(data) {
    return axios({
      url: baseUrl + "/api/business/voucher/czlist",
      method: "POST",
      data
    });
  },
  creatOrder(data) {
    return axios({
      url:
        baseUrl + "/api/unattend/xsq/web/passmonitor/wyfx/qrcode/genterorder",
      method: "POST",
      data
    });
  },
  getAdvertising(params) {
    return axios({
      url:
        baseUrl +
        `/api/unattend/xsq/mobile/park/qrcode/anbo_parkid/${params.parkNo}/${
          params.number
        }`,
      method: "GET"
    });
  },
  // 扫码开卡判断二维码是否过期
  getCodeIsValid(params) {
    return axios({
      url: baseUrl + "/api/business/qrcheck",
      params,
      method: "post"
    });
  },
  // 查询二维码是否有效
  checkcode(data) {
    return axios({
      url: baseUrl + "/api/business/checkcode",
      data,
      method: "post"
    });
  },

  zuijiao(data) {
    return axios({
      url: baseUrl + "/api/nfmobile/zuijiao",
      data,
      method: "post"
    });
  },

  arrearsList(data) {
    return axios({
      url: baseUrl + "/api/park/web/open-system/parkingOrder/arrearsList",
      data,
      method: "post"
    });
  },
  // 查询商户余额
  getUserMoneyByBusNo(params) {
    return axios({
      url: baseUrl + `/api/business/getyuebybusno/${params}`,
      method: "GET"
    });
  }
};

export default yunMobile;



// WEBPACK FOOTER //
// ./src/models/yunMobile.js